import { toggleIdInList } from '@griply/utils';
import { useViewOptionsSectionCollapsed } from 'features/user';
import React, { useCallback } from 'react';
import { PopupMenuCheckbox } from 'shared/components/ui/popup-menu';
import {
  SideNavigationPanelItem,
  SideNavigationPanelSection,
} from 'shared/components/ui/side-navigation-panel';
import { useUpcomingCalendarViewOptions } from 'shared/contexts/upcoming-calendar-view-options';
import { ID } from 'shared/types/id';
import { ViewOptionsCalendarAccount } from 'shared/types/view-options-section';

export type CalendarAccountSectionProps = {
  account: ViewOptionsCalendarAccount;
  isFirst?: boolean;
};

export const CalendarAccountSection: React.FC<CalendarAccountSectionProps> = ({
  account: { id, title, calendars },
  isFirst,
}) => {
  const { viewOptions, updateViewOptions } = useUpcomingCalendarViewOptions();
  const { hiddenCalendarIds } = viewOptions;

  const [collapsed, setCollapsed] = useViewOptionsSectionCollapsed(id);
  const onToggleSection = () => setCollapsed(!collapsed);

  const toggleCalendar = useCallback(
    (calendarId: ID) =>
      updateViewOptions({
        hiddenCalendarIds: toggleIdInList(hiddenCalendarIds, calendarId),
      }),
    [hiddenCalendarIds, updateViewOptions],
  );

  const enabledCount = calendars.filter(
    ({ id }) => !hiddenCalendarIds.includes(id),
  ).length;

  return (
    <SideNavigationPanelSection
      id={id}
      title={title}
      open={!collapsed}
      onToggle={onToggleSection}
      enabledCount={enabledCount}
      totalCount={calendars.length}
      isFirst={isFirst}
    >
      {calendars.map((calendar) => {
        const onToggle = () => toggleCalendar(calendar.id);
        const show = !hiddenCalendarIds.includes(calendar.id);

        return (
          <SideNavigationPanelItem key={calendar.id}>
            <PopupMenuCheckbox
              label={calendar.name}
              checked={show}
              onChange={onToggle}
              color={calendar.color}
              dimmed={!show}
            />
          </SideNavigationPanelItem>
        );
      })}
    </SideNavigationPanelSection>
  );
};
